const megaMenu = ( ( document ) => {
	const _storeMenuItems = ( $megaMenu ) => {
		const subMenu = $megaMenu.querySelector( '.sub-menu' );
		return Array.from( subMenu.children );
	};
	const _constructMegaMenu = ( $megaMenu ) => {
		// const $megaMenu = document.querySelector( '.mega-menu' );
		if ( ! $megaMenu ) return;
		const subMenu = $megaMenu.querySelector( '.sub-menu' );
		const items = Array.from( subMenu.children );
		const columnSize = 4;
		subMenu.innerHTML = '';

		for ( let i = 0; i < items.length; i += columnSize ) {
			const chunk = items.slice( i, i + columnSize );

			const columnLi = document.createElement( 'li' );
			columnLi.classList.add( 'sub-menu-column' );

			const innerUl = document.createElement( 'ul' );
			chunk.forEach( ( li ) => innerUl.appendChild( li ) );

			columnLi.appendChild( innerUl );
			subMenu.appendChild( columnLi );
		}
		// const $menuItems = $megaMenu.querySelectorAll(
		// 	'.menu-item-has-children'
		// );
		//
		// $menuItems.forEach( ( item ) => {
		// 	// console.log( { item } );
		// 	const areaName = item
		// 		.querySelector( '[itemprop="name"]' )
		// 		.innerText.toLowerCase();
		// 	// switch ( areaName ) {
		// 	// 	case 'a':
		// 	// 	case 'b':
		// 	// 	case 'c':
		// 	// 	case 'd':
		// 	// 		item.classList.add( 'is-area-a' );
		// 	// 		break;
		// 	// 	case 'e':
		// 	// 	case 'f':
		// 	// 	case 'g':
		// 	// 	case 'h':
		// 	// 		item.classList.add( 'is-area-b' );
		// 	// 		break;
		// 	// 	case 'i':
		// 	// 	case 'j':
		// 	// 	case 'k':
		// 	// 	case 'l':
		// 	// 		item.classList.add( 'is-area-c' );
		// 	// 		break;
		// 	// 	case 'm':
		// 	// 	case 'n':
		// 	// 	case 'o':
		// 	// 	case 'p':
		// 	// 		item.classList.add( 'is-area-d' );
		// 	// 		break;
		// 	// 	case 'q':
		// 	// 	case 'r':
		// 	// 	case 's':
		// 	// 	case 't':
		// 	// 		item.classList.add( 'is-area-e' );
		// 	// 		break;
		// 	// 	case 'u':
		// 	// 	case 'v':
		// 	// 	case 'w':
		// 	// 	case 'x':
		// 	// 		item.classList.add( 'is-area-f' );
		// 	// 		break;
		// 	// }
		// 	item.classList.add( `is-area-${ areaName }` );
		// 	// console.log( { areaName } );
		// } );
	};

	function _triggerMegaMenu( e ) {
		e.preventDefault();
		document.body.classList.toggle( 'mega-menu-visible' );
	}
	const _initMegaMenu = ( $megaMenu ) => {
		// document.body.classList.remove( 'mega-menu-visible' );
		// console.log( 'init mega menu' );
		// $megaMenu.addEventListener( 'click', _triggerMegaMenu );
		$megaMenu.addEventListener( 'mouseenter', _triggerMegaMenu );

		$megaMenu.addEventListener( 'mouseleave', _triggerMegaMenu );
	};

	// Design and trade view each have their own «Produkte» mega menu in the primary nav.
	const init = () => {
		document.querySelectorAll( '.mega-menu' ).forEach( _initOne );
	};

	const _initOne = ( $megaMenu ) => {
		if ( ! $megaMenu.querySelector( '.sub-menu' ) ) {
			return;
		}
		const menuItems = _storeMenuItems( $megaMenu );
		const mobileMedia = window.matchMedia( '(min-width: 1350px)' );
		if ( mobileMedia.matches ) {
			_constructMegaMenu( $megaMenu );
			_initMegaMenu( $megaMenu );
		}
		mobileMedia.addEventListener( 'change', ( e ) => {
			if ( ! e.matches ) {
				const subMenu = $megaMenu.querySelector( '.sub-menu' );
				$megaMenu.removeEventListener( 'click', _triggerMegaMenu );
				subMenu.innerHTML = '';
				for ( let i = 0; i < menuItems.length; i++ ) {
					subMenu.appendChild( menuItems[ i ] );
				}
				return false;
			}
			_constructMegaMenu( $megaMenu );
			_initMegaMenu( $megaMenu );
		} );
		// $megaMenu.addEventListener( 'click', function ( event ) {
		// 	console.log( { event: event.target } );
		// 	if ( event.target.tagName.toLowerCase() !== 'a' ) {
		// 		document.body.classList.remove( 'mega-menu-visible' );
		// 	}
		// } );
	};

	return {
		init,
	};
} )( document );

export default megaMenu;
